<template>
  <div class="modal-header my-6">
    <div class="text-center">{{ title }}</div>
    <v-divider class="justify-center"/>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import { Name } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class DynameatModalHeader extends Vue {
  @Name 'dynameat-modal-header';

  @Prop({ String, default: '' }) title;
}
</script>
